import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  spinner: {
    margin: '0 auto',
    alignSelf: 'center',
  }
}))

// Custom styling for MUI Spinner
export const Spinner = () => {

  const classes = useStyles();

  return (
    <CircularProgress className={classes.spinner} size={70} /> 
  )
}